"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeroSlideStyled = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  overflow: hidden;\n  color: ", ";\n  text-align: ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var HeroSlideStyled = (0, _uiKit.styled)('div')(_templateObject(), function (_ref) {
  var $color = _ref.$color;
  return $color ? _uiKit.Colors[$color] : _uiKit.Colors['gray800'];
}, function (_ref2) {
  var $align = _ref2.$align;
  return $align ? $align : 'center';
}, function (_ref3) {
  var styles = _ref3.styles;
  return styles;
});
exports.HeroSlideStyled = HeroSlideStyled;